<section1 [sectionIcon]="'lock'"
          [sectionTitle]="'Secure payment' | translate">

    <checkout-expandable [expandableOff]="expandableOff"
                         sectionBody
                         [expandableId]="expandableId">

        <div expandableTitle>
            <address-short [address]="address"></address-short>
        </div>
        <div expandableBody>

            <h6 class="p2 m-t-6 m-t-9-m m-t-9-s">{{ 'Choose payment method' | translate }}</h6>

            <checkout-payment-methods class="block m-t"></checkout-payment-methods>

            <h5 class="s1 p-t-4">{{ 'Billing address' | translate}}</h5>
            <div class="bg-col-51 p-t-4 p-b-4 p-l-3 p-r-3 m-t-4">
                <p class="p1 col-11"
                   [innerHTML]="addressShorterVersion"></p>
            </div>
            <checkout-expandable class="block p-r-2 _payment-step"
                                 [style.margin-top.px]="-40"
                                 [expandContentByDefault]="true">
                <div expandableBody>
                    <checkout-address [data]="address"
                                      [isBilling]="true"></checkout-address>
                </div>
            </checkout-expandable>

            <ng-container *abIf="'(checkoutPromoCode) !B'">
                <basket-view-coupon-form class="block m-t-8"
                                         [source]="'Payment Coupon'"
                                         [isCheckout]="true"></basket-view-coupon-form>
            </ng-container>

            <checkout-submit [paymentMethodCode]="checkout.paymentMethodCode"
                             class="block m-t m-t-9-s m-t-9-m"></checkout-submit>

        </div>
    </checkout-expandable>
</section1>
